<div
  class="drop-area reordering"
  [class.enabled]="canBeDroppedOn$ | async"
  [class.reorder-before]="willReorderBefore$ | async"
  (mouseenter)="registerAsNextObjectForReordering()"
  (mouseleave)="cancelReordering()"
></div>
<div
  class="drop-area nesting-drop-area"
  [class.enabled]="canBeDroppedOn$ | async"
  (mouseenter)="setTargetNestingObject()"
  (mouseleave)="removeTargetNestingObject()"
></div>
<div
  class="drop-area reordering"
  [class.enabled]="canBeDroppedOn$ | async"
  [class.reorder-after]="willReorderAfter$ | async"
  (mouseenter)="registerAsPreviousObjectForReordering()"
  (mouseleave)="cancelReordering()"
></div>
